<template>
  <div>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Academic Service Activities Record</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('closeDialogCom')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <div class="pa-4">
      <v-card v-if="Object.keys(selectedLecture).length != 0" class="mx-auto mb-4" max-width="1500" outlined
                style="background-color: transparent !important;border-color: transparent !important;">
                <v-list-item three-line>
                    <v-list-item-content>
                        <div class="text-overline mb-2">
                            {{ selectedLecture.id }}
                        </div>
                        <v-list-item-title class="text-h5 mt-0 mb-1">
                            {{ selectedLecture.title ? `${selectedLecture.title.short_eng} ${selectedLecture.name} ${selectedLecture.surname}` : `${selectedLecture.name} ${selectedLecture.surname}` }}
                        </v-list-item-title>
                        <v-list-item-subtitle v-if="selectedLecture.department">{{ selectedLecture.department.name_eng }}</v-list-item-subtitle>
                        <v-list-item-subtitle class="mt-3"> updated_at :: {{ selectedLecture.updated_at }}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-avatar tile rounded size="100">
                        <img :src="'https://my.muic.io/api' + selectedLecture.img" />
                    </v-list-item-avatar>
                </v-list-item>
            </v-card>
      <v-card class="mx-auto" max-width="1500" outlined>
        <v-list-item three-line>
          <v-list-item-content>
            <!-- form -->
            <v-form ref="form" v-model="valid" lazy-validation>
              <div class="mt-2 mb-2">
                <v-row gutters>
                  <v-col cols="12" sm="6" md="6">
                    <div class="pa-5">
                      <v-textarea dense filled label="Activity's Title" v-model="formActivity.ActivityTitle"
                        :rules="[rules.required, rules.min3]"></v-textarea>

                      <v-text-field v-model="formActivity.RecordOrganizer" label="Organizer" filled dense
                        :rules="[rules.required]"></v-text-field>

                      <div class="mb-3" v-if="nameTypes.length > 0">
                        <div class="text-subtitle-2 mb-1 grey--text">Select Service Category</div>
                        <v-btn-toggle v-model="selectedNameType" color="primary" class="category-toggle" dense>
                          <v-btn value="" small class="text-capitalize font-weight-bold">
                            All
                          </v-btn>
                          <v-btn v-for="type in nameTypes" :key="type" :value="type" small
                            class="text-capitalize font-weight-bold">
                            {{ type }}
                          </v-btn>
                        </v-btn-toggle>
                      </div>

                      <v-autocomplete :items="filteredActivityTypes" v-model="formActivity.ActivityType" dense
                        label="List of Academic Services and Working Hours" filled persistent-hint
                        :rules="[rules.required]"
                        hint="Other academic/scholarly activities may be submitted for consideration. (Supporting evidence with approval/acknowledgement from the Dean must be provided.)"></v-autocomplete>

                      <!-- {{ formActivity.ActivityType }} -->
                      <div v-if="isOther" class="mt-3">
                        <v-text-field v-model="formActivity.ActivityTypeOther" label="Other Activity" filled
                          dense></v-text-field>
                      </div>

                      <!--  :rules="[rules.required, rules.numeric]" -->
                      <v-text-field v-if="showHourField" class="mt-3" v-model="formActivity.ActivityHour" label="Hours"
                        filled dense></v-text-field>

                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <div class="pa-5">
                      <!-- {{ formActivity.RecordSector }} -->
                      <v-autocomplete :items="optionSector" v-model="formActivity.RecordSector" dense label="Sector"
                        filled persistent-hint :rules="[rules.required]"></v-autocomplete>

                      <!-- date -->
                      <!-- {{ date_start }} - {{ date_end }} -->

                      <!-- start -->

                      <v-menu v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="date_start" label="Start Date" filled readonly v-bind="attrs" v-on="on"
                            :rules="[rules.startRequired]" />
                        </template>

                        <v-date-picker v-model="date_start" no-title scrollable @input="menuStart = false" />
                      </v-menu>

                      <!-- end -->

                      <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="date_end" label="End Date" filled readonly :disabled="!date_start"
                            v-bind="attrs" v-on="on" :rules="[rules.endRequired, rules.endAfterStart]" persistent-hint
                            hint="This work will count the AS score when the activity's end." />
                        </template>

                        <v-date-picker v-model="date_end" no-title scrollable :min="date_start"
                          @input="menuEnd = false" />
                      </v-menu>

                      <v-tooltip top v-if="!date_start">
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on"></div>
                        </template>
                        <span>Please select start date first</span>
                      </v-tooltip>


                      <v-row class="mt-3">
                        <v-col v-for="(file, index) in formActivity.ActivityFile" :key="index" cols="12">
                          <v-file-input v-model="formActivity.ActivityFile[index]" label="Activity File Upload" dense
                            persistent-hint hint="File can be screenshots or meeting logs (.pdf only)" filled
                            prepend-icon="mdi-upload-circle" :rules="[rules.required, rules.pdfOnly]"></v-file-input>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" class="text-center">
                          <v-btn small color="primary" class="mr-3 white--text text-capitalize font-weight-bold"
                            @click="addFileInput">
                            <v-icon left>mdi-plus-circle</v-icon> Add File
                          </v-btn>

                          <v-btn small color="error" class="text-capitalize white--text font-weight-bold"
                            @click="removeFileInput" :disabled="formActivity.ActivityFile.length <= 1">
                            <v-icon left>mdi-minus-circle</v-icon> Remove
                          </v-btn>
                        </v-col>
                      </v-row>

                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </v-list-item-content>
          <!-- <v-list-item-avatar tile size="80" color="grey"></v-list-item-avatar> -->
        </v-list-item>

        <v-card-actions>
          <v-list-item class="grow">
            <v-row align="center" justify="center">
              <v-btn class="text-capitalize font-weight-bold mr-4" @click="resetForm" dense
                color="grey darken-1" outlined>
                Clear
              </v-btn>
              <v-btn class="text-capitalize white--text font-weight-bold" @click="showModalConfirm" dense
                color="primary" depressed>
                Submit
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </div>

    <v-dialog v-model="confirmDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="grey lighten-2">
          <h4 class="font-weight-bold mb-5">Confirm Submission</h4>
        </v-card-title>
        <v-card-text class="text-center">
          {{
            checkForm
              ? `Are you sure you want to submit this activity record ?`
              : `Please check input form`
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="hideModalConfirm">
            Cancel
          </v-btn>
          <div v-if="checkForm">
            <v-btn class="text-capitalize white--text font-weight-bold" color="green darken-3" depressed
              @click="submitActivityRecord" :loading="loading">
              Confirm
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- error main page -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" top>
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
const formActivityRecord = {
  ActivityTitle: "",
  ActivityType: "",
  ActivityTypeOther: "",
  ActivityHour: 0,
  RecordDate: "",
  RecordStart: "",
  RecordEnd: "",
  RecordOrganizer: "",
  RecordSector: "",
  ActivityFile: [""],
  StatusActivity: "approve",
};

export default {
  name: "SheetForm",
  props: {
    selectedLecture: {
      type: Object,
      default: () => ({}),
    },
    activityType: {
      type: Array,
      default: () => [],
    }
  },
  components: {},
  data() {
    return {
      valid: true,
      checkForm: false,
      menuStart: false,
      menuEnd: false,
      date_start: null,
      date_end: null,
      rules: {
        required: (v) => !!v || "This field is required",
        min3: (v) => (v && v.length >= 3) || "Minimum 3 characters",
        numeric: (v) => /^\d+$/.test(v) || "Only numbers allowed",
        pdfOnly(v) {
          if (!v) return true;
          if (Array.isArray(v)) {
            // ถ้า input รองรับหลายไฟล์
            return (
              v.every((file) => file && file.name && file.name.endsWith(".pdf")) ||
              "Only .pdf files allowed"
            );
          } else {
            return (v && v.name && v.name.endsWith(".pdf")) || "Only .pdf file allowed";
          }
        },
        // dateRules: v => (v && this.dates.length == 2) || 'This field is required',
        startRequired: (v) => !!v || "Please select start date",

        endRequired: (v) => !!v || "Please select end date",

        endAfterStart: (v) =>
          !v ||
          !this.formActivity.RecordStart ||
          v >= this.formActivity.RecordStart ||
          "End date must be after start date",
      },

      optionSector: [
        {
          text: "Private",
          value: "Private",
        },
        {
          text: "Public",
          value: "Public",
        },
        {
          text: "Nonprofit Organization",
          value: "Nonprofit",
        },
      ],
      optionActivityType: [],
      optionStatusActivity: [
        {
          text: "Save - บันทึกผลงานเพื่อกลับมาแก้ไข",
          value: "save",
        },
        {
          text: "Send - ส่งผลงานเพื่อรอการตรวจสอบ",
          value: "send",
        },
      ],
      //
      errorMsg: null,
      formActivity: Object.assign({}, formActivityRecord),
      menu1: false,
      menu2: false,

      confirmDialog: false,
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "",
      },
      selectedNameType: null,
    };
  },
  watch: {
    date_start(val) {
      this.formActivity.RecordStart = val;
      if (this.formActivity.RecordEnd && this.formActivity.RecordEnd < val) {
        this.formActivity.RecordEnd = null;
        this.date_end = null;
      }
    },
    date_end(val) {
      this.formActivity.RecordEnd = val;
    },
    "formActivity.ActivityType"(newVal) {
      const selected = this.optionActivityType.find(
        (item) => parseInt(item.value) === parseInt(newVal)
      );
      if (selected) {
        if (selected.detail !== "Others") {
          this.formActivity.ActivityTypeOther = "";
        }
        // Set ActivityHour to 1 if the field is not supposed to be shown
        this.$nextTick(() => {
          if (!this.showHourField) {
            this.formActivity.ActivityHour = 0;
          }
        });
      }
    },
    selectedNameType() {
      // Clear activity selection if it's not in the filtered list
      if (this.formActivity.ActivityType) {
        const isMatch = this.filteredActivityTypes.some(
          (item) => item.value === this.formActivity.ActivityType
        );
        if (!isMatch) {
          this.formActivity.ActivityType = "";
        }
      }
    },
  },
  computed: {
    selectedItem() {
      return this.optionActivityType.find(
        (i) => i.id === this.formActivity.ActivityType
      );
    },
    isOther() {
      return this.selectedItem?.detail === "Others";
    },
    showHourField() {
      if (!this.selectedItem) return false;
      const category = this.selectedItem.name_type;
      const detail = this.selectedItem.detail;

      return (
        category === "Teaching-Oriented activities" ||
        category === "Others" ||
        (detail && detail.includes("Assessor (EdPex, AUN-QA. etc.)"))
      );
    },
    nameTypes() {
      const types = this.optionActivityType.map((item) => item.name_type);
      let uniqueTypes = [...new Set(types)];
      // Sort and keep 'Other' at the end
      const otherIndex = uniqueTypes.findIndex(
        (t) =>
          t && (t.toLowerCase() === "other" || t.toLowerCase() === "others")
      );
      if (otherIndex !== -1) {
        const other = uniqueTypes.splice(otherIndex, 1)[0];
        uniqueTypes.push(other);
      }
      return uniqueTypes;
    },
    filteredActivityTypes() {
      if (!this.selectedNameType) return this.optionActivityType;
      return this.optionActivityType.filter(
        (item) => item.name_type === this.selectedNameType
      );
    },
  },
  mounted() {
    this.getActivityType();
  },
  methods: {
    addFileInput() {
      this.formActivity.ActivityFile.push("");
    },
    removeFileInput() {
      if (this.formActivity.ActivityFile.length > 1) {
        this.formActivity.ActivityFile.pop();
      }
    },
    async getActivityType() {
      this.optionActivityType = [];
      try {
        const resType = await this.$http.get(
          `/academic-service/activity-types/`
        );
        if ([200, 201].includes(resType.status)) {
          this.optionActivityType = resType.data
            .filter((a) => a.status === "on")
            .map((item) => {
              let displayText = `${item.detail} (${parseFloat(item.point).toFixed(2)} hours )`;

              const isTeaching = item.name_type === "Teaching-Oriented activities";
              const isAssessor = item.detail && item.detail.includes("Assessor (EdPex, AUN-QA. etc.)");

              if (isTeaching || isAssessor) {
                displayText = `${item.detail} (actual hours x ${parseFloat(item.point).toFixed(2)})`;
              } else if (item.detail === "Others") {
                displayText = `${item.detail}`;
              }

              return {
                text: displayText,
                value: item.id,
                ...item,
              };
            });
          // console.log(this.optionActivityType)
        } else {
          throw { resType };
        }
      } catch (error) {
        console.log(error);
      }
    },
    getHours() {
      console.log(this.formActivity.ActivityType);
    },
    // controll form
    resetForm() {
      this.formActivity = Object.assign({}, formActivityRecord);
      this.formActivity.ActivityFile = [""];
      this.date_start = null;
      this.date_end = null;
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    showSnackbar(message, color) {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    showModalConfirm() {
      this.confirmDialog = true;
      if (this.$refs.form.validate()) {
        this.checkForm = true;
      } else {
        this.checkForm = false;
      }
    },
    hideModalConfirm() {
      this.confirmDialog = false;
      this.checkForm = false;
    },
    async fileInActivity(sentformSend, idMainActivity) {
      try {
        const updateMainActivity = await this.$http.patch(
          `/academic-service/main-activities/${idMainActivity}/`,
          sentformSend,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if ([200, 201].includes(updateMainActivity.status)) {
          console.log(updateMainActivity.data);
        } else {
          throw { updateMainActivity };
        }
      } catch (error) {
        if (error.response) this.showSnackbar("Error patching files", "error");
      }
    },
    async submitActivityRecord() {
      this.loading = true;
      this.confirmDialog = false;

      const sendFormActivity = new FormData();
      sendFormActivity.append("name_academic", this.formActivity.ActivityTitle);
      sendFormActivity.append("activity_type", this.formActivity.ActivityType);
      sendFormActivity.append(
        "hour_activity",
        this.showHourField ? this.formActivity.ActivityHour : 1
      );
      sendFormActivity.append("status", this.formActivity.StatusActivity);
      sendFormActivity.append("sector", this.formActivity.RecordSector);
      sendFormActivity.append("date_start", this.formActivity.RecordStart);
      sendFormActivity.append("date_end", this.formActivity.RecordEnd);
      sendFormActivity.append(
        "organizer_record",
        this.formActivity.RecordOrganizer
      );
      sendFormActivity.append(
        "activity_other",
        !["", "", "null", null].includes(this.formActivity.ActivityTypeOther)
          ? this.formActivity.ActivityTypeOther
          : `-`
      );

      // Add the user's account identifier so backend knows who the activity is for
      if (this.selectedLecture && this.selectedLecture.muic_account) {
        sendFormActivity.append("muic_account_aj_username", this.selectedLecture.muic_account);
      }

      try {
        const resSubmit = await this.$http.post(
          "/academic-service/main-activities/",
          sendFormActivity,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if ([200, 201].includes(resSubmit.status)) {
          console.log("✅ Main Activity Created:", resSubmit.data);

          const patchIdfile = new FormData();

          if (this.formActivity.ActivityFile.length) {
            for (let i = 0; i < this.formActivity.ActivityFile.length; i++) {
              if (!this.formActivity.ActivityFile[i]) continue;

              const sendActivityFile = new FormData();
              sendActivityFile.append(
                "file",
                this.formActivity.ActivityFile[i]
              );

              try {
                const uploadRes = await this.$http.post(
                  `/academic-service/main-activities/${resSubmit.data.id}/files/`,
                  sendActivityFile,
                  { headers: { "Content-Type": "multipart/form-data" } }
                );

                if ([200, 201].includes(uploadRes.status)) {
                  patchIdfile.append("files", uploadRes.data.id);
                  console.log(`📎 Uploaded file ${i + 1}:`, uploadRes.data);
                }
              } catch (errUpload) {
                console.error("File upload failed:", errUpload);
              }
            }

            await this.fileInActivity(patchIdfile, resSubmit.data.id);
          }

          this.resetForm();
          this.$refs.form.resetValidation();
          this.showSnackbar(
            "✅ Activity record submitted successfully!",
            "success"
          );

          setTimeout(() => {
            this.$emit('closeDialogCom');
          }, 1500);
        } else {
          throw new Error("Unexpected response status");
        }
      } catch (error) {
        console.error("❌ Submission Error:", error);
        const errorMessage =
          error.response?.data?.detail ||
          "Failed to submit the record. Please try again.";
        this.showSnackbar(errorMessage, "red darken-4");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.category-toggle {
  display: flex !important;
  flex-wrap: wrap !important;
  width: 100%;
  border: none !important;
  background-color: transparent !important;
}

.category-toggle .v-btn {
  flex: 1 1 auto;
  min-width: 120px;
  max-width: 100%;
  margin: 2px !important;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-radius: 4px !important;
}

.category-toggle .v-btn--active {
  background-color: #1976D2 !important;
  color: white !important;
  border-color: #1976D2 !important;
}

@media (max-width: 600px) {
  .category-toggle .v-btn {
    flex: 1 1 calc(50% - 4px);
    /* 2 columns on small mobile */
    min-width: 0;
  }
}

@media (max-width: 350px) {
  .category-toggle .v-btn {
    flex: 1 1 100%;
    /* Fully stack on very small screens */
  }
}
</style>
